module.exports = __webpack_public_path__ + "img/partner_img5.07e97d68.png";